import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

function parseFieldGroup(fieldGroup) {
  return {
    description: fieldGroup.description,
    general: JSON.parse(fieldGroup.general),
    per_warehouse: JSON.parse(fieldGroup.per_warehouse),
  };
}
function processWarehouseFields(item, warehouse_fields, warehouses, state) {
  const warehouse = {};

  warehouse_fields.forEach((field) => {
    if (item[field]) {
      warehouse[field] = item[field];
    }
  });
  warehouse.warehouse_id = item.id;

  state.warehouses.forEach((value, key) => {
    if (warehouse_fields.includes(key)) {
      warehouse[key] = value;
    }
  });

  if (Object.keys(warehouse).length > 0) {
    warehouses.push(warehouse);
  }
}

export default {
  loadAppDetails({ commit }, appId) {
    return GraphQlClient.query(`
      query {
        GetSelfServiceAppAndInstallation(app_id: "${appId}"){
          app_name
          image_url
          subtitle
          visible
          public_doc
          credentials {
            description
            general
            per_warehouse
          }
          config {
            description
            general
            per_warehouse
          }
          sysnode {
            description
            general
            per_warehouse
          }
          instructions {
            description
            general
            per_warehouse
          }
          warehouse_fields
        }
      }`).then((result) => {
        const response = result.data.GetSelfServiceAppAndInstallation;

        const propertiesToParse = ['credentials', 'config', 'sysnode'];

        propertiesToParse.forEach((property) => {
          if (response[property]) {
            response[property] = parseFieldGroup(response[property]);
          }
        });

        commit('setAppDetails', response);

        return response;
      });
  },
  getAppSelfServiceListApps({ commit }) {
    commit('setLoading', true);

    return GraphQlClient.query(`
      query {
        GetSelfServiceAppsList {
          id
          app_name
          image_url
          subtitle
          visible
          editable
          status
        }
      }`)
      .then((result) => {
        const response = result.data.GetSelfServiceAppsList;
        commit('setSelfServiceList', response
          .filter(app => app.visible)
          .sort((app1, app2) => app1.app_name.localeCompare(app2.app_name)));
        commit('clearAppNameFilterFieldValue');
        commit('setLoading', false);
      })
      .catch((error) => {
        commit('setLoading', false);
        throw new Error(error);
      });
  },
  stepInstallSelfService({ commit, state }, appId) {
    const warehouses = [];

    const { warehouse_fields } = state.appDetails;

    state.includedWarehouses.forEach((item) => {
      processWarehouseFields(item, warehouse_fields, warehouses, state);
    });

    state.appConfig.warehouses = warehouses;

    const body = {
      app_id: appId,
      app_config: JSON.stringify(state.appConfig),
      app_contact: state.contact,
    };
    return GraphQlClient.mutation(`
      mutation ($app_id: Int!, $app_config: String!, $app_contact: SelfServiceContact) {
        stepInstallSelfService(app_id: $app_id, app_config: $app_config, app_contact: $app_contact) {
              ok
              message
              installation_id
            }
        }
      `, body).then((result) => {
        const response = result.data.stepInstallSelfService;
        commit('setInstallationId', response.installation_id);
        return Promise.resolve(response);
      });
  },
  async getCredentials(context, appId) {
    const query = `query($app_id: Int!) {
      GetIntelipostCredentials(app_id: $app_id) {
        sysnode {
            lp_api_key
        }
        ftp {
            host
            username
            password
        }
      }
    }`;
    const vars = {
      app_id: appId,
    };
    return GraphQlClient.query(query, vars)
      .then(result => result.data.GetIntelipostCredentials);
  },

  getWarehouses({ commit }) {
    return GraphQlClient.query(`
        query {
          warehouses {
            id
            name
            official_name
            federal_tax_payer_id
            address {
              zip_code
            }
          }
        }
      `).then((result) => {
        commit('setWarehouses', result.data.warehouses);
      });
  },

  getClientInfo({ commit }) {
    return GraphQlClient.query(`
        query {
          client {
            id
            official_name
            common_name
          }
        }
      `).then((result) => {
        commit('setClientInfo', result.data.client);
      });
  },

  async validateApp({ commit }, args) {
    try {
      const body = {
        app_id: args.app_id.toString(),
        app_config: JSON.stringify(args.app_config),
      };

      const { data } = await GraphQlClient.mutation(`
        mutation ($app_id: String!, $app_config: String!) {
          validateAppSelfService(app_id: $app_id, app_config: $app_config) {
                ok
                message
              }
          }
        `, body);

      const validateApp = data.validateAppSelfService;

      return Promise.resolve(validateApp);
    } catch (e) {
      ScToast.open({
        message: 'Falha ao validar credenciais',
        duration: 20000,
        type: 'is-danger',
      });
      return Promise.reject(e);
    }
  },
  setFilteredAppList({ commit }, filteredAppList) {
    commit('setSelfServiceListSearched', filteredAppList);
  },
  clearAppNameFilterField({ commit }) {
    commit('clearAppNameFilterFieldValue', '');
  },
  setAppSelfServiceWithoutFilter({ commit }, appsWithoutFilter) {
    commit('setAppSelfServiceWithoutFilter', appsWithoutFilter);
  },
  lpAttachTemporaryFile({ commit }, args) {
    const vars = {
      base64: args.base64,
      content_type: args.content_type,
      file_name: args.file_name,
    };
    return GraphQlClient.mutation(`
      mutation (
        $base64: String!,
        $content_type: String!,
        $file_name: String!,
        ) {
          lpAttachTemporaryFile(
            base64: $base64,
            content_type: $content_type,
            file_name: $file_name,
            ) {
              ok
              message
              temporary_attachment_id
          }
      }
    `, vars).then(result => result.data.lpAttachTemporaryFile);
  },
  async createNewLpRequestTickets({ commit }, args) {
    try {
      const vars = {
        lp_data: JSON.stringify(args.lp_data),
        quote_table: JSON.stringify(args.quote_table),
        attachments: args.attachments,
      };
      const { data } = await GraphQlClient.mutation(`
        mutation (
          $lp_data: String!,
          $quote_table: String,
          $attachments: [NewLpIntegrationRequestAttachment]) {
      
            newLpIntegrationRequestTicket(
              lp_data: $lp_data,
              quote_table: $quote_table,
              attachments: $attachments) {
                ok
                message
                issue_key
            }
        }
      `, vars);

      ScToast.open(
        {
          message: `Formulário enviado com sucesso! "${data.newLpIntegrationRequestTicket.issue_key}"`,
          duration: 20000,
          type: 'is-success',
        },
      );
      return Promise.resolve(data);
    } catch (e) {
      ScToast.danger('Falha ao enviar formulário. Tente novamente.');
      commit('setLoading', false);
      return Promise.reject(e);
    }
  },
  getLogisticProviderList({ commit }) {
    const body = {};
    return GraphQlClient.mutation(`
    mutation ($body: String) {
      logisticProviderList(body: $body)
    }`, body).then((result) => {
      const response = result.data.logisticProviderList;
      response.push('Outra transportadora');
      commit('setLogisticProviderList', response);
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/store/actions.js